import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAD0rLQ9FiBO34TBaCbMZBFyk01nIoDIHc",
  authDomain: "interactive-quiz-836ba.firebaseapp.com",
  projectId: "interactive-quiz-836ba",
  storageBucket: "interactive-quiz-836ba.firebasestorage.app",
  messagingSenderId: "625692108361",
  appId: "1:625692108361:web:f2847ee8f05d587b4e4198",
  measurementId: "G-DKH7PLTW5K"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
